import { UserTypeWisePagesConfig } from '../constant';
import { AuthUserState } from './dto/response';


var CryptoJS = require('crypto-js');

export const isLoggedIn = (state: AuthUserState) => {
  const { token, expires_at, user } = state;
  //const currentTime = Date.now();
  //return !!user && !!token && !!expires_at && expires_at > currentTime;
  return !!user && !!token && !!expires_at
}

export const isAuthorizedPage = (userType: string) => {
  
  const path = window.location.pathname;
//   console.log(UserTypeWisePagesConfig[userType] && (UserTypeWisePagesConfig[userType].indexOf(path) > -1 || UserTypeWisePagesConfig[userType].indexOf(path + '/') > -1),"userType");

  return UserTypeWisePagesConfig[userType] && (UserTypeWisePagesConfig[userType].indexOf(path) > -1 || UserTypeWisePagesConfig[userType].indexOf(path + '/') > -1) ? true : false;
}

export function encryptText(plainText: any) {
  if (!plainText) return ''
  let key = CryptoJS.enc.Utf8.parse('2b7e151628aed2a6abf7158809cf4f3c');
  let iv = CryptoJS.enc.Utf8.parse('3ad77bb40d7a3660');
  let config = { keySize: 128, iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 };
  let encPassword = CryptoJS.AES.encrypt(plainText, key, config);
  return encPassword.ciphertext.toString(CryptoJS.enc.Base64);
}

export const decryptText = (text: any) => {
  if (!text) return ''
  let key = CryptoJS.enc.Utf8.parse('2b7e151628aed2a6abf7158809cf4f3c');
  let iv = CryptoJS.enc.Utf8.parse('3ad77bb40d7a3660');
  let config = { keySize: 128, iv: iv, mode: CryptoJS.mode.CBC, padding: CryptoJS.pad.Pkcs7 };
  try {
    let encPassword = CryptoJS.AES.decrypt(text, key, config);
    return encPassword.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    try {
      return JSON.parse(text)
    } catch (err1) {
      return text || ''
    }
  }
}

export const isObject = (obj: any) => typeof obj === 'object' && !Array.isArray(obj) && obj !== null

export const stableSort = <T>(array: readonly T[], comparator: (a: T, b: T) => number) => {
  const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) {
      return order;
    }
    return a[1] - b[1];
  });
  return stabilizedThis.map((el) => el[0]);
}

export const getComparator = <Key extends keyof any>(
  order: any,
  orderBy: Key,
): (
  a: { [key in Key]: any },
  b: { [key in Key]: any },
) => number => {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

export const descendingComparator = <T>(a: T, b: T, orderBy: keyof T) => {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export const getFilenameFromURL = (url: string) => {
  if (!url) return '';
  const urlParts = url.split('/');
  let filenameWithExtension = urlParts[urlParts.length - 1];
  filenameWithExtension = filenameWithExtension.split('?')[0];

  return filenameWithExtension;
}


export const convertDateFormat = (dateString: any) => {
  const currentDate = new Date(dateString)
  return `${currentDate.getFullYear()}-${String(currentDate.getMonth() + 1).padStart(2, '0')}-${String(currentDate.getDate()).padStart(2, '0')}`
}

export const getHTTPSURL = (url: string) => {
  if (!url) return '';
  if (!url.startsWith("http://") && !url.startsWith("https://")) {
      return "https://" + url;
  }
  return url;
}

export const capitalizeFirst = (text?: string) =>
    text ? text.charAt(0).toUpperCase() + text.slice(1) : '';